/**
 * @author AndréK
 * 07/03/2022
 */

//#region - BaseURL

//Development
// const baseURL = "https://localhost:5001/api";

//Produção
const baseURL = "https://projetonvi24.sgoas.nvi.com.br/api";


const appointments = {
    baseURL
};

export default appointments;
